import React from "react";
import { clsx } from "clsx";
import { cn } from "../utils/style";

function Tabs({ tabs, get, set, rightSide, hideOnMobile = true }) {
  if (!tabs) return null;
  return (
    <div className="my-4">
      <div className={cn({ "hidden sm:block": hideOnMobile })}>
        <div className="border-b border-slate-200/60">
          <nav
            className={cn(`-mb-px flex flex-wrap gap-x-10`, {
              "justify-end": !!rightSide,
            })}
            aria-label="Tabs"
          >
            {tabs.map((tab) => {
              const active = tab?.column === get;
              return (
                <span
                  key={tab?.column}
                  onClick={() => set(tab?.column)}
                  className={clsx(
                    "relative cursor-pointer select-none flex items-center whitespace-nowrap py-5 px-1 text-[11px] font-black uppercase tracking-[0.2em] transition-all duration-300",
                    active
                      ? "text-primary-600"
                      : "text-slate-400 hover:text-slate-600",
                  )}
                  aria-current={active ? "page" : undefined}
                >
                  <span className="relative z-10">{tab?.name}</span>

                  {tab?.count > 0 && (
                    <span
                      className={clsx(
                        "ms-2.5 rounded-full px-2 py-0.5 text-[9px] font-black transition-all duration-300",
                        active
                          ? "bg-primary-500 text-white shadow-sm"
                          : "bg-slate-100 text-slate-500 group-hover:bg-slate-200",
                      )}
                    >
                      {tab?.count}
                    </span>
                  )}

                  {/* Premium Underline Indicator */}
                  {active && (
                    <div className="absolute bottom-0 start-0 end-0 h-1 bg-primary-500 rounded-t-full shadow-[0_-1px_10px_rgba(59,130,246,0.3)] animate-in fade-in slide-in-from-bottom-1 duration-500" />
                  )}
                </span>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Tabs;
